<script setup lang="ts">
  import { ref } from "vue"
  import AppSubMenu from "./AppSubMenu.vue"

  const model = ref([
    {
      label: "Accueil",
      icon: "pi pi-home",
      to: "/",
    },
    {
      label: "Fonds",
      icon: "pi pi-briefcase",
      to: "/fonds",
    },
    {
      label: "Philosophie de gestion",
      icon: "pi pi-compass",
      to: "/philosophieDeGestion",
    },
    {
      label: "Pôles d'investissement",
      icon: "pi pi-sitemap",
      to: "/poleInvestissement",
    },
    {
      label: "Finance durable",
      icon: "pi pi-globe",
      to: "/financeDurable",
    },
    {
      label: "Nous connaître",
      icon: "pi pi-users",
      to: "/nousConnaitre",
    },
    {
      label: "Lettres d'investissement",
      icon: "pi pi-envelope",
      to: "/lettresInvestissement",
    },
    {
      label: "Arago",
      icon: "pi pi-star",
      to: "/arago",
    },
    {
      label: "Contacts",
      icon: "pi pi-phone",
      to: "/contacts",
    },
  ])
</script>

<template>
  <nav class="main-menu">
    <AppSubMenu :model="model" />
  </nav>
</template>

<style lang="scss" scoped>
  .main-menu {
    width: 100%;
    background: var(--menu-bg, #fff);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    display: flex;
    // justify-content: center;
    align-items: center;
    padding: 0 2rem;
    min-height: 64px;
    z-index: 10;
    position: relative;
    transition: background 0.2s;
  }
  :deep(.dark) .main-menu {
    background: #18181b !important;
  }
  @media (max-width: 900px) {
    .main-menu {
      padding: 0 0.5rem;
    }
    .horizontal-menu {
      flex-direction: column;
      gap: 0.5rem;
      align-items: flex-start;
      // width: 100vw;
      background: var(--menu-bg, #fff);
      position: absolute;
      left: 0;
      top: 64px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
      // padding: 1rem 0.5rem;
      min-width: 180px;
      display: flex !important;
    }
  }
  @media (min-width: 901px) {
    .horizontal-menu {
      display: flex !important;
      position: static;
      background: transparent;
      box-shadow: none;
      padding: 0;
      min-width: unset;
      width: auto;
    }
  }
  /* Réduction de l'espace entre l'icône et le texte du menu */
  .layout-menuitem-icon {
    margin-right: 0em !important;
    font-size: 1.2em;
    vertical-align: middle;
  }
</style>
